export const BUILD_PARTS = [
    {
        key: 'cpu',
        buildType: 'cpu',
        backendKey: 'processor',
        menuKey: 'cpu',
        name: 'CPU',
        label: 'Processor',
        url: 'cpu',
        itemType: 'cpu',
        itemId: 1
    },
    {
        key: 'graphics',
        buildType: 'gpu',
        backendKey: 'graphics',
        menuKey: 'graphics',
        name: 'Graphics',
        label: 'Graphics',
        url: 'gpu',
        itemType: 'gpu',
        itemId: 5
    },
    {
        key: 'motherboard',
        buildType: 'motherboard',
        backendKey: 'motherboard',
        menuKey: 'motherboard',
        name: 'Motherboard',
        label: 'Motherboard',
        url: 'motherboard',
        itemType: 'motherboard',
        itemId: 2
    },
    {
        key: 'ram',
        buildType: 'ram',
        backendKey: 'ram',
        menuKey: 'ram',
        name: 'RAM',
        label: 'RAM',
        url: 'ram',
        itemType: 'ram',
        itemId: 3
    },
    {
        key: 'storage',
        buildType: 'storage',
        backendKey: 'storage',
        menuKey: 'storage',
        name: 'Storage',
        label: 'Storage',
        url: 'storage',
        itemType: 'storage',
        itemId: 4
    },
    {
        key: 'case',
        buildType: 'case',
        backendKey: 'case',
        menuKey: 'case',
        name: 'Case',
        label: 'Case',
        url: 'case',
        itemType: 'case',
        itemId: 7
    },
    {
        key: 'psu',
        buildType: 'psu',
        backendKey: 'psu',
        menuKey: 'psu',
        name: 'Power Supply',
        label: 'Power Supply',
        url: 'psu',
        itemType: 'psu',
        itemId: 6
    }
]

export const BUILD_PART_ORDER = BUILD_PARTS.map((part) => part.key)

export function normalizeMenuKey(type){
    if(!type){ return '' }
    var key = type.toString().toLowerCase()
    if(key == 'processor'){ return 'cpu' }
    if(key == 'gpu'){ return 'graphics' }
    if(key == 'power supply'){ return 'psu' }
    return key
}

export function normalizeBuildType(type){
    if(!type){ return '' }
    var key = type.toString().toLowerCase()
    if(key == 'processor'){ return 'cpu' }
    if(key == 'graphics'){ return 'gpu' }
    if(key == 'power supply'){ return 'psu' }
    return key
}

export function getPartDefinition(type){
    var menuKey = normalizeMenuKey(type)
    var buildType = normalizeBuildType(type)
    for(var i = 0; i < BUILD_PARTS.length; i++){
        var part = BUILD_PARTS[i]
        if(part.key == menuKey
        || part.menuKey == menuKey
        || part.backendKey == menuKey
        || part.buildType == buildType
        || part.name.toLowerCase() == menuKey
        || part.label.toLowerCase() == menuKey){
            return part
        }
    }
    return null
}

export function createMenuOptions(){
    var options = {}
    BUILD_PARTS.forEach((part) => {
        options[part.menuKey] = {
            type: part.itemType,
            name: part.name,
            url: part.url,
            item: {
                type: part.itemType,
                id: part.itemId,
                contents: null,
            },
        }
    })
    return options
}

export function createBuildSlots(){
    return BUILD_PARTS.map((part) => {
        return {
            id: part.itemId,
            type: part.buildType,
            contents: null
        }
    })
}

export function orderedMenuOptions(options){
    var ordered = {}
    if(!options){ return ordered }

    BUILD_PARTS.forEach((part) => {
        if(options[part.menuKey]){
            ordered[part.menuKey] = options[part.menuKey]
        }
    })

    Object.keys(options).forEach((key) => {
        if(!ordered[key]){
            ordered[key] = options[key]
        }
    })

    return ordered
}

export function getBuildSlot(build, type){
    if(!build){ return null }
    var buildType = normalizeBuildType(type)
    for(var i = 0; i < build.length; i++){
        if(build[i] && build[i].type == buildType){
            return build[i]
        }
    }
    return null
}

export function getBuildContents(build, type){
    var slot = getBuildSlot(build, type)
    return slot ? slot.contents : null
}

export function orderedBuildEntries(build, fieldExceptions){
    var entries = []
    if(!build){ return entries }
    var exceptions = fieldExceptions || []

    BUILD_PARTS.forEach((part) => {
        var key = part.backendKey
        if(exceptions.includes(key)){ return }
        if(build[key] === undefined){ return }
        entries.push({
            key: key,
            label: part.label,
            value: build[key],
            idValue: build[key + '_id'],
            definition: part
        })
    })

    Object.keys(build).forEach((key) => {
        if(exceptions.includes(key) || key.includes('_')){ return }
        for(var i = 0; i < entries.length; i++){
            if(entries[i].key == key){ return }
        }
        entries.push({
            key: key,
            label: key,
            value: build[key],
            idValue: build[key + '_id'],
            definition: getPartDefinition(key)
        })
    })

    return entries
}
